import Box from "@mui/material/Box";
import "../assets/PrologueImage.css";
import PrologueImageProps from "../models/prologueImageProps";

function PrologueImage({ title, subtitle, image, child }: PrologueImageProps) {
  return (
    <Box position="relative" className="prologue-image">
      <img src={image} alt="Logo" className="image-content" />
      {title && (
        <div
          className="text-overlay"
          style={{ fontFamily: "Source Sans Pro SemiBold" }}
        >
          <div className="title">{title}</div>
          <div
            className="subtitle"
            style={{ fontFamily: "Source Sans Pro SemiBold" }}
          >
            {subtitle}
          </div>
        </div>
      )}
      {child && (
        <Box
          position="absolute"
          left={0}
          right={0}
          bottom={{ xs: 18, md: 28 }}
          width="100%"
          display="flex"
          justifyContent="center"
          zIndex={2}
        >
          {child}
        </Box>
      )}
    </Box>
  );
}

export default PrologueImage;
